/* eslint-disable react-native/no-inline-styles */
/*
B2B-5937 — Sales Order / SKP External reminder.
Inline: attention icon + red label (list rows). Banner: pink bar on top of a detail card with
optional description and action link — one line on web, title then wrapped description on mobile.
*/

import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';

const fontSize = isWeb ? 13 : 14;

const AttentionIcon = () => (
  <Image
    style={styles.icon}
    width={16}
    height={16}
    svg={true}
    source={require('@assets/img/icons/attention-red.svg')}
  />
);

const ReminderNotice = ({
  title,
  description,
  actionLabel,
  onAction,
  banner,
  style,
  testID,
}) => {
  if (!title) {
    return false;
  }

  if (!banner) {
    return (
      <View testID={testID} style={[styles.row, { marginTop: 8 }, style]}>
        <AttentionIcon />
        <SociollaText style={styles.title}>{title}</SociollaText>
      </View>
    );
  }

  const hasAction = !!(actionLabel && onAction);

  if (isWeb) {
    return (
      <View testID={testID} style={[styles.banner, style]}>
        <View style={[styles.row, { flex: 1 }]}>
          <AttentionIcon />
          <SociollaText style={{ flex: 1, fontSize }}>
            <SociollaText type="medium" style={styles.title}>
              {title}
            </SociollaText>
            {description ? (
              <SociollaText style={styles.description}>
                {' '}
                {description}
              </SociollaText>
            ) : (
              false
            )}
          </SociollaText>
        </View>
        {hasAction ? (
          <TouchableOpacity
            testID={`${testID}-action`}
            activeOpacity={0.6}
            onPress={onAction}>
            <SociollaText type="medium" style={styles.action}>
              {actionLabel}
            </SociollaText>
          </TouchableOpacity>
        ) : (
          false
        )}
      </View>
    );
  }

  return (
    <View testID={testID} style={[styles.banner, styles.bannerMobile, style]}>
      <View style={styles.row}>
        <AttentionIcon />
        <SociollaText type="medium" style={styles.title}>
          {title}
        </SociollaText>
      </View>
      {description || hasAction ? (
        <SociollaText style={styles.descriptionMobile}>
          {description ? (
            <SociollaText style={styles.description}>
              {description}{' '}
            </SociollaText>
          ) : (
            false
          )}
          {hasAction ? (
            <SociollaText
              testID={`${testID}-action`}
              type="medium"
              style={styles.action}
              onPress={onAction}>
              {actionLabel}
            </SociollaText>
          ) : (
            false
          )}
        </SociollaText>
      ) : (
        false
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: 8,
  },
  title: {
    fontSize,
    color: Colors.red3,
  },
  description: {
    fontSize,
    color: Colors.grey2,
  },
  descriptionMobile: {
    marginTop: 4,
    marginLeft: 24,
    lineHeight: 22,
  },
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 16,
    paddingHorizontal: 16,
    backgroundColor: Colors.reminderBannerBg,
  },
  bannerMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  action: {
    marginLeft: isWeb ? 16 : 0,
    fontSize,
    color: Colors.blue1,
  },
});

ReminderNotice.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  banner: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  testID: PropTypes.string,
};

export default ReminderNotice;
